import * as React from 'react';

import { cn } from 'lib/utils';
import { DollarSign, BadgeCent } from 'lucide-react';

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    variant?: 'default' | 'currency-dollar' | 'currency-cents';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, variant = 'default', ...props }, ref) => {
        const getInput = (extraClassName?: string) => (
            <input
                type={type}
                className={cn(
                    'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                    className,
                    extraClassName,
                )}
                ref={ref}
                {...props}
                data-1p-ignore
            />
        );

        if (variant === 'default') {
            return getInput();
        }

        if (variant === 'currency-dollar') {
            return (
                <div className="relative w-full justify-center">
                    <DollarSign className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 transform text-foreground" />
                    {getInput('pl-8')}
                </div>
            );
        }

        if (variant === 'currency-cents') {
            return (
                <div className="relative w-full justify-center">
                    <BadgeCent className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 transform text-foreground" />
                    {getInput('pl-8')}
                </div>
            );
        }
    },
);
Input.displayName = 'Input';

export { Input };
